import { render, staticRenderFns } from "./CardImport.vue?vue&type=template&id=166f66ce"
import script from "./CardImport.vue?vue&type=script&lang=js"
export * from "./CardImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports